module.exports = __webpack_public_path__ + "static/media/Ellipse_red.f0174e75.svg";